import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function ForWhoSection() {
  const forYou = ['Quieres generar ingresos con algo tuyo, aunque hoy estés empezando desde cero.', 'Tienes habilidades/experiencia, pero no sabes convertirla en una oferta clara.', 'Te cuesta enfocarte y terminar.', 'Quieres propósito, pero con pasos reales.'];
  const notForYou = ['Buscas resultados sin ejecutar.', 'Quieres crear algo enorme antes de validar.', 'No piensas publicar tu oferta cuando esté lista.'];
  return <section className="py-20 px-4 bg-cream-50" data-id="element-64">
      <div className="max-w-6xl mx-auto" data-id="element-65">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-66">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border-t-8 border-sage-500" data-id="element-67">
            <h3 className="text-3xl font-serif text-brown-800 mb-8" data-id="element-68">
              Esto es para ti si…
            </h3>
            <ul className="space-y-6" data-id="element-69">
              {forYou.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-70">
                  <CheckCircle2Icon className="w-6 h-6 text-sage-500 flex-shrink-0 mt-1" data-id="element-71" />
                  <span className="text-lg text-brown-800 leading-relaxed" data-id="element-72">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-cream-100 p-8 md:p-12 rounded-3xl border-t-8 border-terracotta-500 opacity-90" data-id="element-73">
            <h3 className="text-3xl font-serif text-brown-800 mb-8" data-id="element-74">
              No es para ti si…
            </h3>
            <ul className="space-y-6" data-id="element-75">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-76">
                  <XCircleIcon className="w-6 h-6 text-terracotta-500 flex-shrink-0 mt-1" data-id="element-77" />
                  <span className="text-lg text-stone-600 leading-relaxed" data-id="element-78">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}